module.exports = __webpack_public_path__ + "static/media/calendar-week.77616683.svg";